import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.btSupported
    ? _c(
        "div",
        [
          _vm.entryMode
            ? _c(
                "div",
                { staticClass: "d-flex align-center justify-end flex-wrap" },
                [
                  _vm.configured
                    ? _c(
                        VBtn,
                        {
                          staticClass: "ma-1",
                          attrs: {
                            color: _vm.autoPrint
                              ? _vm.connected
                                ? "green"
                                : "amber darken-2"
                              : "",
                            dark: _vm.autoPrint,
                            outlined: !_vm.autoPrint,
                          },
                          on: {
                            click: function ($event) {
                              _vm.autoPrint = !_vm.autoPrint
                            },
                          },
                        },
                        [
                          _c(VIcon, { attrs: { left: "" } }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.autoPrint
                                    ? "mdi-printer"
                                    : "mdi-printer-off"
                                ) +
                                " "
                            ),
                          ]),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.autoPrint
                                  ? "พิมพ์อัตโนมัติ ON"
                                  : "ไม่พิมพ์ OFF"
                              ) +
                              " "
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    VChip,
                    {
                      staticClass: "ma-1",
                      attrs: {
                        small: "",
                        color:
                          _vm.autoPrint && !_vm.connected
                            ? "amber lighten-4"
                            : "",
                        outlined: !(_vm.autoPrint && !_vm.connected),
                      },
                      on: {
                        click: function ($event) {
                          _vm.dialog = true
                        },
                      },
                    },
                    [
                      _c(
                        VIcon,
                        { attrs: { left: _vm.configured, small: "" } },
                        [_vm._v("mdi-printer-wireless")]
                      ),
                      _vm.configured
                        ? _c("span", [_vm._v(_vm._s(_vm.statusText))])
                        : _vm._e(),
                      _c(VIcon, { attrs: { right: "", small: "" } }, [
                        _vm._v("mdi-cog-outline"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.status && _vm.entryMode
            ? _c(
                "div",
                {
                  staticClass: "text-caption grey--text text-right mr-1",
                  staticStyle: { "white-space": "pre-wrap" },
                },
                [_vm._v(" " + _vm._s(_vm.status) + " ")]
              )
            : _vm._e(),
          _c(
            VDialog,
            {
              attrs: { "max-width": "420" },
              model: {
                value: _vm.dialog,
                callback: function ($$v) {
                  _vm.dialog = $$v
                },
                expression: "dialog",
              },
            },
            [
              _c(
                VCard,
                [
                  _c(
                    VCardTitle,
                    { staticClass: "text-h6" },
                    [
                      _c(VIcon, { attrs: { left: "" } }, [
                        _vm._v("mdi-printer-wireless"),
                      ]),
                      _vm._v(" ตั้งค่าเครื่องพิมพ์ / Printer setup "),
                    ],
                    1
                  ),
                  _c(
                    VCardText,
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex align-center mb-3" },
                        [
                          _c(
                            VBtn,
                            {
                              attrs: {
                                small: "",
                                color: "primary",
                                loading: _vm.busy,
                              },
                              on: { click: _vm.connect },
                            },
                            [
                              _c(VIcon, { attrs: { left: "", small: "" } }, [
                                _vm._v("mdi-bluetooth"),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.connected
                                      ? "เชื่อมต่อใหม่ / Reconnect"
                                      : "เชื่อมต่อ / Connect"
                                  ) +
                                  " "
                              ),
                            ],
                            1
                          ),
                          _c("span", { staticClass: "ml-3 text-caption" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.connected
                                    ? _vm.printerName
                                    : "ยังไม่เชื่อมต่อ / not connected"
                                ) +
                                " "
                            ),
                          ]),
                        ],
                        1
                      ),
                      _c(VDivider, { staticClass: "mb-3" }),
                      _c("div", { staticClass: "text-caption mb-1" }, [
                        _vm._v("ขนาดป้าย / Label size"),
                      ]),
                      _c(
                        VRadioGroup,
                        {
                          staticClass: "mt-0 mb-3",
                          attrs: { dense: "", "hide-details": "" },
                          model: {
                            value: _vm.sizeKey,
                            callback: function ($$v) {
                              _vm.sizeKey = $$v
                            },
                            expression: "sizeKey",
                          },
                        },
                        _vm._l(_vm.sizes, function (s) {
                          return _c(VRadio, {
                            key: s.key,
                            attrs: { label: s.title, value: s.key },
                          })
                        }),
                        1
                      ),
                      _c(VTextField, {
                        staticClass: "mb-4",
                        attrs: {
                          type: "number",
                          min: "1",
                          max: "20",
                          dense: "",
                          outlined: "",
                          "hide-details": "",
                          label: "สำเนา / Copies per entry",
                        },
                        model: {
                          value: _vm.copies,
                          callback: function ($$v) {
                            _vm.copies = _vm._n($$v)
                          },
                          expression: "copies",
                        },
                      }),
                      _c(
                        "div",
                        { staticClass: "text-caption grey--text mt-2" },
                        [
                          _vm._v(
                            " เปิดเฉพาะเครื่องที่มีเครื่องพิมพ์อยู่ข้างๆ / Turn on only on the phone next to a printer. Settings are kept on this phone. "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    VCardActions,
                    [
                      _c(
                        VBtn,
                        {
                          attrs: {
                            text: "",
                            disabled: _vm.busy || !_vm.connected,
                          },
                          on: { click: _vm.testPrint },
                        },
                        [
                          _c(VIcon, { attrs: { left: "", small: "" } }, [
                            _vm._v("mdi-file-find-outline"),
                          ]),
                          _vm._v(" ทดสอบ / Test print "),
                        ],
                        1
                      ),
                      _c(VSpacer),
                      _c(
                        VBtn,
                        {
                          attrs: { color: "primary", text: "" },
                          on: {
                            click: function ($event) {
                              _vm.dialog = false
                            },
                          },
                        },
                        [_vm._v("ปิด / Done")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticStyle: {
                position: "absolute",
                left: "-10000px",
                top: "0",
                "pointer-events": "none",
              },
              attrs: { "aria-hidden": "true" },
            },
            [
              _vm.pending
                ? _c("label-sticker", {
                    ref: "sticker",
                    attrs: {
                      entry: _vm.pending.entry,
                      worksheet: _vm.worksheet,
                      parameters: _vm.parameters,
                      "qr-data-url": _vm.pending.qrDataUrl,
                      "lot-index": _vm.pending.lotIndex,
                      "commodity-name": _vm.commodityName,
                      "product-info": _vm.productInfo,
                      "company-name": _vm.companyName,
                      "company-address": _vm.companyAddress,
                      "company-phone": _vm.companyPhone,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }